import angular from 'angular';

export default angular.module('cms.creator.config.sections', [])
  .factory('SectionsLibraryService', function () {


    this.sections = {};

    /**
     * @param sectionDefinition {icon: '', label: '', type: ''}
     */
    let registerSection = (sectionDefinition) => {

      if (!('type' in sectionDefinition)) {
        console.error('Definition object should contain type');
      }

      if (!('icon' in sectionDefinition)) {
        console.error('Definition object should contain icon');
      }

      if (!('label' in sectionDefinition)) {
        console.error('Definition object should contain label');
      }

      if(this.sections[sectionDefinition.type]){
          console.error('Definition of object type ' + sectionDefinition.type + ' already exist (label: ' + sectionDefinition.label + ', group: ' + sectionDefinition.group + ')');
      }

      this.sections[sectionDefinition.type] = sectionDefinition;
    };

    let getSections = (group, includeHidden) => {
      let allSections = Object.values(this.sections).filter(el => (el.group === group));
      return includeHidden ? allSections : allSections.filter(el => el.hidden !== true);
    };

    let getSectionDefinition = (type) => {
      return this.sections[type];
    };

    return {
      registerSection: registerSection,
      getSections: getSections,
      getSectionDefinition: getSectionDefinition
    };

  })
  .name


// WEBPACK FOOTER //
// ./src/cmsCore/Creator/SectionsLibrary/SectionsLibraryService.js